class AncillaryDescriptionMybUIModel {
  constructor({
    AncillaryDisplay = '',
    ancillaryDisplay = '',
    backgroundModal = '',
    colorHeadline = '',
    headlineModal = '',
    modalDisplay = '',
    Description = '',
    hasAlternativeAncillary = false,
    Headline = '',
    Subtitle = '',
    Type = '',
    title = '',
    Totem = {},
    Image = {},
    Image2 = {},
    Image3 = {},
    Image4 = {},
    Image5 = {},
    TituloModal = '',
    DescripcionModal = '',
    TotemImageModal = {},
    linkModal = '',
    TotemImageModal2 = {},
    TotemImageModal3 = {},
    TotemImageModal4 = {},
    TotemImageModal5 = {},
    FooterModal = '',
    TotemLarge = {},
    benefits = {},
    DescriptionMarkDown = '',
  }) {
    this.AncillaryDisplay = AncillaryDisplay;
    this.ancillaryDisplay = ancillaryDisplay;
    this.backgroundModal = backgroundModal;
    this.colorHeadline = colorHeadline;
    this.hasAlternativeAncillary = hasAlternativeAncillary;
    this.headlineModal = headlineModal;
    this.modalDisplay = modalDisplay;
    this.Description = Description;
    this.Headline = Headline;
    this.Subtitle = Subtitle;
    this.Type = Type;
    this.title = title;
    this.Totem = Totem;
    this.Image = Image;
    this.Image2 = Image2;
    this.Image3 = Image3;
    this.Image4 = Image4;
    this.Image5 = Image5;
    this.TituloModal = TituloModal;
    this.DescripcionModal = DescripcionModal;
    this.TotemImageModal = TotemImageModal;
    this.TotemImageModal2 = TotemImageModal2;
    this.TotemImageModal3 = TotemImageModal3;
    this.TotemImageModal4 = TotemImageModal4;
    this.TotemImageModal5 = TotemImageModal5;
    this.FooterModal = FooterModal;
    this.TotemLarge = TotemLarge;
    this.linkModal = linkModal;
    this.benefits = benefits;
    this.DescriptionMarkDown = DescriptionMarkDown;
  }
}

export default AncillaryDescriptionMybUIModel;